export default {
  unReadCount (state) {
    return state.unReadCount;
  },
};
